import {
  Breadcrumb,
  Button,
  Col,
  Form,
  Input,
  message,
  Radio,
  Row,
  Select,
  Space,
  Table,
  Tooltip,
  Typography,
  Spin
} from 'antd';
import { useEffect, useState, useCallback, useMemo } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Option } from 'antd/es/mentions';
import { ReactComponent as Back } from '../../Images/Back.svg';
import AutoOpenSelect from '../SelectComponent/AutoOpenSelect';
import {
  fetchBundleOutWardListById,
  fetchBundleOutWardListByItem,
  finalizeBundleOutward,
} from '../../slices/bundleoutward';
import TextArea from 'antd/es/input/TextArea';
import { PlusOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import { ReactComponent as EditIcon } from '../../Images/EditIcon.svg';


import { fetchWorkOrderList, resetWorkOrderList } from '../../slices/work-order';
import { fetchVehicleList, resetVehicleList } from '../../slices/vehicle';
import dayjs from 'dayjs';
import debounce from 'lodash/debounce';

function EditBundleOutWard() {
  const [form] = Form.useForm();
  const [btnLoading, setBtnLoading] = useState(false);
  const [bundleOutwardData, setBundleOutwardData] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedWorkOrderBundles, setSelectedWorkOrderBundles] = useState([]);
  const [bundleOutwardId, setBundleOutwardId] = useState(null);
  const [page, setPage] = useState(1);
  const [workOrderItems, setWorkOrderItem] = useState([]);
  const [pagesize, setPageSize] = useState(100);
  const { list: workOrderList = [], status } = useSelector(
    state => state.workOrder,
  );
  const { list: vehicleList = [], status: vehicleStatus } = useSelector(state => state.vehicle);
  const [workOrderId, setworkOrderId] = useState();
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [disableCheck, setDisableCheck] = useState(false);
  const [vehicleSearchValue, setVehicleSearchValue] = useState('');
  const [vehicleHasMore, setVehicleHasMore] = useState([]);
  const [vehicleFetching, setVehicleFetching] = useState(false);

  const rowSelection = {
    selectedRowKeys,
    onChange: selectedRowKeys => {
      setSelectedRowKeys(selectedRowKeys);
      setDisableCheck(selectedRowKeys.length !== 0);
    },
    getCheckboxProps: record => ({
      disabled: record.added_bundles === 0,
    }),
  };

  const fetchData = async () => {
    try {
      const response = await dispatch(
        fetchBundleOutWardListById({ id }),
      ).unwrap();

      const outwardData = response?.results?.data?.[0];
      console.log(outwardData);
      if (response?.results?.success == true) {
        setBundleOutwardData(outwardData);
        form.setFieldsValue({
          work_order_number: outwardData?.work_order_number,
          workorder: outwardData?.work_order_id,
          vehicle_no: outwardData?.vehicle_id,
          transporter_name: outwardData?.transporter_name,
          shift: outwardData?.shift,
          dispatch_to: outwardData?.status,
          remarks: outwardData?.remarks ?? '',
        });
        setBundleOutwardId(outwardData?.id);


        setWorkOrderItem([{
          id: outwardData?.work_order_id,
          work_order_number: outwardData?.work_order_number,
          order_date: outwardData?.order_date,
          order_no: outwardData?.work_order_number,
          purchase_order_no: outwardData?.purchase_order_number,
          purchase_order_date: outwardData?.purchase_order_date,
          customer_name: outwardData?.bill_to?.customer_name, // ✅
        }]);
        setworkOrderId(outwardData?.work_order_id);

        const tableResponse = await dispatch(
          fetchBundleOutWardListByItem({
            workOrderId: outwardData?.work_order_id,
            page: 1,
            pagesize: 1000,
            bundleOutwardId: outwardData?.id,
          }),
        ).unwrap();

        const transformedData = tableResponse?.results?.data.map(
          (item, index) => ({
            ...item,
            SrNo: index + 1,
          }),
        );
        setSelectedWorkOrderBundles(transformedData);
      }
    } catch (error) {
      console.error('Failed to fetch quotation:', error);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);
  useEffect(() => {
    dispatch(resetWorkOrderList());

    dispatch(
      fetchWorkOrderList({
        page: 1,
        pagesize: 1000,
      }),
    );
    return () => {
      dispatch(resetWorkOrderList());
    };
  }, [dispatch]);

  const handleAdd = data => {
    navigate(
      `/add-bundle-for-outward/${data.workorder_detail_id}/${bundleOutwardId}`,
    );
  };

  const handleFinalizeBundle = () => {
    const values = {
      workorder_detail_id: selectedRowKeys,
      outward_id: Number(bundleOutwardId),
    };
    dispatch(finalizeBundleOutward({ values }))
      .unwrap()
      .then(result => {
        setBtnLoading(false);
        message.success('Bundle OutWard Finalize Successfully!');
        navigate("/bundle-outward");
      })
      .catch(error => {
        setBtnLoading(false);
        if (typeof error === 'object' && error !== null) {
          const messages = [];
          for (const key in error) {
            if (Array.isArray(error[key])) {
              messages.push(`${key}: ${error[key].join(', ')}`);
            }
          }
          if (messages.length > 0) {
            message.error(messages.join('; '));
          } else {
            message.error('An unknown error occurred.');
          }
        } else {
          message.error(
            typeof error === 'string' ? error : 'An unknown error occurred.',
          );
        }
      });
  };


  const handlePrint = id => {
    window.open(`/print-draft-bundle-outword/${id}`);
  };

  const workOrder = (
    <Form.Item
      name="workorder"
      label="Select Work Order"
      rules={[{ required: true, message: 'Please select workorder' }]}
    >
      <AutoOpenSelect
        placeholder="Order No - Order Date - PO Number - PO Date - Customer Name"
        showSearch
        optionFilterProp="label"
        optionLabelProp="label"
        rules={[{ required: true, message: 'Please Select Work Order Item!' }]}
        style={{ width: '100%' }}
        disabled
      >
        {workOrderItems.map(wo => (
          <Option
            key={wo?.id}
            value={wo?.id}
            label={`${dayjs(wo?.order_date).format('DD/MM/YYYY')} - ${wo?.order_no} | ${wo?.purchase_order_no} - ${dayjs(wo?.purchase_order_date).format('DD/MM/YYYY')} | ${wo?.bill_to?.customer_name}`}
          >
            {`${dayjs(wo?.order_date).format('DD/MM/YYYY')} - ${wo?.order_no} | ${wo?.purchase_order_no} - ${dayjs(wo?.purchase_order_date).format('DD/MM/YYYY')} | ${wo?.bill_to?.customer_name}`}
          </Option>
        ))}
      </AutoOpenSelect>
    </Form.Item>
  );

  const handleTableChange = (pagination, filters, sorter) => {
    setPageSize(pagination.pageSize);
  };

  const columns = [
    {
      title: 'Sr. No.',
      dataIndex: 'SrNo',
      key: 'SrNo',
      width: '80px',
    },
    {
      title: 'Item Description',
      dataIndex: 'item_description',
      key: 'workorder_die_number',
      width: '350px',
      render: (_, record) => record.item_description,
    },
    {
      title: 'Total Bundles',
      dataIndex: 'total_bundle',
      key: 'total_bundle',
    },

    {
      title: 'Total Pieces',
      dataIndex: 'total_piece',
      key: 'total_piece',
    },
    {
      title: 'Total Weight(kg)',
      dataIndex: 'total_weight',
      key: 'total_weight',
      sorter: true,
    },
    {
      title: 'Added Bundles',
      dataIndex: 'added_bundles',
      key: 'added_bundles',
    },
    {
      title: 'Added Pieces',
      dataIndex: 'added_bundles_pieces',
      key: 'added_bundles_pieces',
    },

    {
      title: 'Added Weight(kg)',
      dataIndex: 'added_bundles_weight',
      key: 'added_bundles_weight',
      sorter: true,
    },
    {
      title: 'Ready Bundles',
      dataIndex: 'ready_bundles',
      key: 'ready_bundles',
    },
    {
      title: 'Ready Pieces',
      dataIndex: 'ready_bundles_pieces',
      key: 'ready_bundles_pieces',
    },

    {
      title: 'Ready Weight(kg)',
      dataIndex: 'ready_bundles_weight',
      key: 'ready_bundles_weight',
      sorter: true,
    },
    {
      title: 'Status',
      dataIndex: 'status',
      width: '200px',
      key: 'status',
    },
    {
      title: 'Action',
      dataIndex: 'action',
      key: 'action',
      render: (_, record) => (
        <Space size="middle">
          {record.added_bundles === 0 ? (
            < Tooltip placement="top" title={'Add Bundle For OutWard'}>
              <span onClick={() => handleAdd(record)}>
                <PlusOutlined style={{ cursor: 'pointer' }} />
              </span>
            </Tooltip>
          ) : (
            < Tooltip placement="top" title={'Edit Bundle For OutWard'} >
              <span onClick={() => handleAdd(record)}>
                <EditIcon style={{ cursor: 'pointer' }} />
              </span>
            </Tooltip >
          )}
        </Space >
      ),
    },
  ];

   const loadVehicleTypes = async (page) => {
      if (vehicleFetching || !vehicleHasMore) return;
  
      setVehicleFetching(true);
      const response = await dispatch(
        fetchVehicleList({
          page,
          pagesize: 20
        })
      );
      console.log(response?.payload);
      if (response?.payload?.next === null) {
        console.log("no more data");
        setVehicleHasMore(false);
      }
      setVehicleFetching(false);
    };
  
    const debouncedVehicleSearch = useMemo(() => debounce((value) => {
      setVehicleSearchValue(value);
      // setWorkOrderPage(1);
      setVehicleHasMore(true);
    }, 500), []); // 300ms delay for work order search
  
    const handleVehicleSearch = useCallback((value) => {
      setVehicleSearchValue(value);
      debouncedVehicleSearch(value);
    }, [debouncedVehicleSearch]);
  
    const handleVehicleDropdownScroll = (e) => {
      const { scrollTop, scrollHeight, clientHeight } = e.target;
      if (scrollHeight - scrollTop <= clientHeight + 10) {
        loadVehicleTypes(1);
      }
    };
  
    useEffect(() => {
      dispatch(resetVehicleList());
      loadVehicleTypes(1);
    }, []);

  return (
    <>
      <div className="sticyaction">
        <div className="sticky-header">
          <Row
            className="pagenamerow mb-0 "
            justify="space-between"
            align="middle"
          >
            <Col>
              <h2>Bundle Outward Manage Items</h2>
              <div className="bredcrumbwrp">
                <Link className="back" onClick={(() => { navigate(-1) })}>
                  <Back /> BACK
                </Link>
                <Breadcrumb
                  items={[
                    { title: <Link to="/dashboard">Home</Link> },
                    { title: <Link to="/bundle-outward">Bundle OutWard</Link> },
                    { title: 'Bundle Outward Manage Items   ' },
                  ]}
                />
              </div>
            </Col>
            <Col>
              <Space size="small">
                <Link>
                  <Tooltip title="Finalize">
                    <Button
                      disabled={!disableCheck}
                      style={{ backgroundColor: '#e0f8e0' }}
                      onClick={() => handleFinalizeBundle()}
                    >
                      Finalize Outward
                    </Button>
                  </Tooltip>
                </Link>
                <Link>
                  <Tooltip title="Print Draft">
                    <Button
                      style={{ backgroundColor: '#FFFBF6' }}
                      onClick={() => handlePrint(id)}
                    >
                      Print Draft Outward
                    </Button>
                  </Tooltip>
                </Link>
              </Space>
            </Col>
          </Row>
        </div>
      </div>
      <div className="formwrapper">
        <Form layout="vertical" form={form}>
          <Row gutter={16}>
            <Col xs={24} sm={8} xl={6} xxl={4}>
              {workOrder}
            </Col>

            <Col xs={24} sm={8} xl={6} xxl={4}>
            <Form.Item
                name="vehicle_no"
                label="Vehicle Number"
                rules={[{ required: true, message: 'Please Select Vehicle!' }]}
              >
                <Select
                  placeholder="Order Date - Order No - PO Number - PO Date - Customer Name"
                  onPopupScroll={handleVehicleDropdownScroll}
                  onSearch={handleVehicleSearch}
                  searchValue={vehicleSearchValue}
                  showSearch
                  filterOption={false}
                  style={{ width: '100%' }}
                  optionLabelProp="label"
                  notFoundContent={
                    vehicleFetching || vehicleStatus !== 'succeeded' ? (
                      <div style={{ textAlign: 'center' }}>
                        <Spin size="small" />
                      </div>
                    ) : vehicleList.length === 0 ? (
                      <div style={{ textAlign: 'center', padding: '8px' }}>
                        No vehicle found
                      </div>
                    ) : null
                  }
                  loading={vehicleFetching || vehicleStatus !== 'succeeded'}
                >
                  {vehicleList?.map(vh => (
                    <Option key={vh.id} value={vh.id} label={vh.vehicle_no} >{vh?.vehicle_no}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
              {/* <Form.Item
                name="vehicle_no"
                label="Vehicle Number"
                rules={[
                  {
                    pattern: /^[A-Za-z0-9 ]+$/,
                    message: 'Only letters, numbers, and spaces are allowed',
                  },
                ]}
              >
                <Input placeholder="Enter Vehicle Number" disabled />
              </Form.Item> */}
            </Col>

            <Col xs={24} sm={8} xl={6} xxl={4}>
              <Form.Item name="transporter_name" label="Transporter Name">
                <Input placeholder="Enter Transporter Name" disabled />
              </Form.Item>
            </Col>

            <Col xs={24} sm={8} xl={6} xxl={4}>
              <Form.Item
                name="shift"
                label="Shift"
                rules={[{ required: true, message: 'Please select shift' }]}
              >
                <AutoOpenSelect placeholder="Select Shift" disabled>
                  <Option value="A">A</Option>
                  <Option value="B">B</Option>
                </AutoOpenSelect>
              </Form.Item>
            </Col>
            <Col xs={24} sm={8} xl={6} xxl={4}>
              <Form.Item
                name="dispatch_to"
                label="Dispatch To"
                rules={[{ required: true, message: 'Please select dispatch to' }]}
              >
                <Radio.Group disabled>
                  <Radio value="Warehouse">Warehouse</Radio>
                  <Radio value="Customer">Customer</Radio>
                </Radio.Group>
              </Form.Item>
            </Col>
            <Col xs={24} sm={8} xl={6} xxl={4} du>
              <Form.Item name="remarks" label="Remarks">
                <TextArea placeholder="Enter Remarks" disabled />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </div>
      <Typography.Title level={4} style={{ textAlign: 'center' }}>
        Work Order Items
      </Typography.Title>
      <Table
        rowKey="workorder_detail_id"
        rowSelection={rowSelection}
        columns={columns}
        dataSource={selectedWorkOrderBundles || []}
        pagination={{
          defaultCurrent: page,
          defaultPageSize: pagesize,
          showTotal: total => `Total ${total} items`,
          showSizeChanger: true,
        }}
        onChange={handleTableChange}
        pageSizeOptions={["20", "50", "100"]}
        scroll={{ x: '600px' }}
      />
    </>
  );
}

export default EditBundleOutWard;
